import { createBlueprint as e } from "@made-people/blueprint";
const t = e({
  slots: {
    base: "bg-background-surface-2 rounded-md animate-pulse aspect-portrait"
  },
  variants: {
    size: {
      portrait: { base: "aspect-portrait" },
      product: { base: "aspect-product" },
      square: { base: "aspect-square" },
      wide: { base: "aspect-wide" }
    }
  }
});
export {
  t as skeletonCardBlueprint
};
//# sourceMappingURL=index-blueprint.es.js.map
